// Source: NPCI PSP handle lists (TPAP, PPI, BHIM, NETC), researched 2026-04-05.
export const VALID_UPI_HANDLES: ReadonlySet<string> = new Set([
    'abcdicici',
    'abfspay',
    'amazonpay',
    'apl',
    'aubank',
    'axisb',
    'axisbank',
    'axl',
    'barodampay',
    'bpaywallet',
    'bpunity',
    'cred',
    'cub',
    'dhani',
    'digikhata',
    'ebixcash',
    'equitas',
    'fam',
    'fbl',
    'fifederal',
    'fkaxis',
    'freoicici',
    'goaxb',
    'hdfcbank',
    'ibl',
    'icici',
    'idbi',
    'idfcbank',
    'idfcnetc',
    'idfcpay',
    'ikwik',
    'indus',
    'inhdfc',
    'jarunity',
    'jkb',
    'jupiteraxis',
    'kbaxis',
    'kotak',
    'kphdfc',
    'kvb',
    'liv',
    'mahb',
    'mairtel',
    'mbk',
    'mufin',
    'mvhdfc',
    'naviaxis',
    'niyoicici',
    'nye',
    'obopay',
    'okaxis',
    'okhdfcbank',
    'okicici',
    'oksbi',
    'omni',
    'oneyes',
    'oxymoney',
    'paulpay',
    'paymoni',
    'paytm',
    'payu',
    'payworld',
    'phonepe',
    'pinelabs',
    'pingpay',
    'pnb',
    'pockets',
    'ptaxis',
    'pthdfc',
    'ptsbi',
    'ptyes',
    'pzw',
    'rapl',
    'rmrbl',
    'sbi',
    'seyes',
    'shriramhdfcbank',
    'sib',
    'slice',
    'spicepay',
    'superyes',
    'tapay',
    'tapicici',
    'tbl',
    'timecosmos',
    'topay',
    'trans',
    'unionbank',
    'upi',
    'waaxis',
    'wahdfcbank',
    'waicici',
    'wasbi',
    'yapl',
    'ybl',
    'yescred',
    'yescurie',
    'yesfam',
    'yesg',
    'yesgo',
    'yespop',
    'yestp',
]);

export const UPI_PROVIDER_BANK_LOOKUP: Readonly<Record<string, string>> = Object.freeze({
    abcdicici: 'ICICI Bank',
    abfspay: 'Aditya Birla Payments Bank',
    amazonpay: 'Amazon Pay (Axis Bank)',
    apl: 'Axis Bank',
    aubank: 'AU Small Finance Bank',
    axisb: 'Axis Bank',
    axisbank: 'Axis Bank',
    axl: 'Axis Bank',
    barodampay: 'Bank of Baroda',
    bpaywallet: 'BharatPe (Bank Partner)',
    bpunity: 'Unity Small Finance Bank',
    cred: 'CRED (Bank Partner)',
    cub: 'City Union Bank',
    dhani: 'Dhani (Bank Partner)',
    digikhata: 'DigiKhata (Bank Partner)',
    ebixcash: 'EbixCash (Bank Partner)',
    equitas: 'Equitas Small Finance Bank',
    fam: 'FamApp (Bank Partner)',
    fbl: 'Federal Bank',
    fifederal: 'Federal Bank',
    fkaxis: 'Axis Bank',
    freoicici: 'ICICI Bank',
    goaxb: 'Axis Bank',
    hdfcbank: 'HDFC Bank',
    ibl: 'ICICI Bank',
    icici: 'ICICI Bank',
    idbi: 'IDBI Bank',
    idfcbank: 'IDFC FIRST Bank',
    idfcnetc: 'IDFC FIRST Bank',
    idfcpay: 'IDFC FIRST Bank',
    ikwik: 'iKwik (Bank Partner)',
    indus: 'IndusInd Bank',
    inhdfc: 'HDFC Bank',
    jarunity: 'Unity Small Finance Bank',
    jkb: 'Jammu & Kashmir Bank',
    jupiteraxis: 'Axis Bank',
    kbaxis: 'Axis Bank',
    kotak: 'Kotak Mahindra Bank',
    kphdfc: 'HDFC Bank',
    kvb: 'Karur Vysya Bank',
    liv: 'LivQuik (Bank Partner)',
    mahb: 'Bank of Maharashtra',
    mairtel: 'Airtel Payments Bank',
    mbk: 'MobiKwik',
    mufin: 'Mufin (Bank Partner)',
    mvhdfc: 'HDFC Bank',
    naviaxis: 'Axis Bank',
    niyoicici: 'ICICI Bank',
    nye: 'Niyo (Bank Partner)',
    obopay: 'OBOPAY (Bank Partner)',
    okaxis: 'Axis Bank',
    okhdfcbank: 'HDFC Bank',
    okicici: 'ICICI Bank',
    oksbi: 'State Bank of India',
    omni: 'OmniCard (Bank Partner)',
    oneyes: 'YES Bank',
    oxymoney: 'Oxyzo Money (Bank Partner)',
    paulpay: 'Paul Merchants (Bank Partner)',
    paymoni: 'PayMoni (Bank Partner)',
    paytm: 'Paytm Payments Bank',
    payu: 'PayU (Bank Partner)',
    payworld: 'Payworld (Bank Partner)',
    phonepe: 'PhonePe (Multi-bank)',
    pinelabs: 'Pine Labs (Bank Partner)',
    pingpay: 'PingPay (Bank Partner)',
    pnb: 'Punjab National Bank',
    pockets: 'ICICI Bank',
    ptaxis: 'Axis Bank',
    pthdfc: 'HDFC Bank',
    ptsbi: 'State Bank of India',
    ptyes: 'YES Bank',
    pzw: 'PayZapp (HDFC Bank)',
    rapl: 'Axis Bank',
    rmrbl: 'RBL Bank',
    sbi: 'State Bank of India',
    seyes: 'YES Bank',
    shriramhdfcbank: 'HDFC Bank',
    sib: 'South Indian Bank',
    slice: 'slice (Bank Partner)',
    spicepay: 'Spice Money (Bank Partner)',
    superyes: 'YES Bank',
    tapay: 'Tata Pay (Bank Partner)',
    tapicici: 'ICICI Bank',
    tbl: 'Bank Partner',
    timecosmos: 'Cosmos Bank',
    topay: 'Topay (Bank Partner)',
    trans: 'TRANServ (Bank Partner)',
    unionbank: 'Union Bank of India',
    upi: 'NPCI / BHIM',
    waaxis: 'Axis Bank',
    wahdfcbank: 'HDFC Bank',
    waicici: 'ICICI Bank',
    wasbi: 'State Bank of India',
    yapl: 'Axis Bank',
    ybl: 'YES Bank',
    yescred: 'YES Bank',
    yescurie: 'YES Bank',
    yesfam: 'YES Bank',
    yesg: 'YES Bank',
    yesgo: 'YES Bank',
    yespop: 'YES Bank',
    yestp: 'YES Bank',
});
